import { Dispatch, SetStateAction } from "react";
import { ButtonStyled } from "./styles";

interface iButton extends React.ButtonHTMLAttributes<HTMLButtonElement> {
	showModal?: Dispatch<SetStateAction<boolean>>;
	$backgroundColor?: string;
	$color?: string;
	children: React.ReactNode;
}

export const Button = ({ showModal, $backgroundColor, $color, children }: iButton) => {
	const attrs = {
		$backgroundColor: $backgroundColor,
		$color: $color,
		onClick: showModal && (() => { showModal(true) })
	}

	return (
		<ButtonStyled
			{...attrs}>
			{children}
		</ButtonStyled >
	)
};
